var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRectangleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 4,
  height: 4,
  viewBox: "0 0 4 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  fill: "#A4A4A4"
})));
export { SvgRectangleIcon as ReactComponent };
export default __webpack_public_path__ + "assets/e0f2e692.svg";